"use client";
import { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { trimText } from "@/lib/trimText";
import Image from "next/image";
import { Badge } from "@/components/ui/badge";
import Link from "next/link";
import { cn } from "@/lib/utils";
import { formatCurrency } from "@/utils/formatCurrency";

const BrandProducts = ({ brandProducts }) => {
  const [books, setBooks] = useState([]);

  useEffect(() => {
    setBooks(brandProducts);
  }, [brandProducts]);

  return (
    <Card className="min-w-[280px] h-fit overflow-hidden border-brand-light shadow-brand-sm rounded-2xl">
      <CardHeader className="bg-brand-light/40">
        <CardTitle className="text-lg text-brand-navy font-semibold">
          Brand Products
        </CardTitle>
      </CardHeader>
      <Separator className="bg-brand-light" />
      <CardContent>
        <div className="flex flex-col divide-y divide-brand-light">
          {books?.slice(0, 4)?.map((book) => (
            <Link
              href={`/product/${book?.slug}`}
              className="flex gap-2 py-2 group"
              key={book?._id}
            >
              <Image
                src={book?.images?.[0]}
                alt={book?.title}
                width={50}
                height={50}
                className="rounded-lg object-contain"
              />
              <div className="w-full">
                <h1 className="text-sm font-medium text-brand-navy group-hover:text-brand-sky transition-colors">
                  {trimText(book?.title, 25)}
                </h1>
                <p className="mt-1 text-xs text-muted-foreground">
                  {trimText(book?.author?.name, 20)}
                </p>
                <div className="flex items-center justify-between">
                  <div className="flex items-start flex-col">
                    <p className="text-sm text-brand-deep font-semibold">
                      {formatCurrency(Math.round(book?.discountedPrice))}
                    </p>
                    <p className="text-sm text-muted-foreground line-through">
                      {formatCurrency(book?.price)}
                    </p>
                  </div>
                  {book?.discount === 0 ? null : (
                    <Badge className="gradient-primary select-none text-white text-xs shadow-brand-sm">
                      {Math.ceil(book?.discount)}% off
                    </Badge>
                  )}
                </div>
              </div>
            </Link>
          ))}
        </div>
      </CardContent>
      <CardFooter className="p-0">
        <Link
          href={`/brand?search=${books?.[0]?.brand}`}
          className={cn(
            "mx-auto py-3",
            books?.length > 4 ? "block" : "hidden"
          )}
          title="Explore Products Brand"
        >
          <button className="group relative overflow-hidden bg-white border border-brand-light rounded-lg px-4 py-2 transition-colors hover:border-brand-sky">
            <span className="absolute inset-0 w-2.5 gradient-primary transition-all duration-300 ease-out group-hover:w-full"></span>
            <span className="relative font-semibold group-hover:text-white text-sm text-brand-deep transition-colors">
              See All Brands
            </span>
          </button>
        </Link>
      </CardFooter>
    </Card>
  );
};

export default BrandProducts;